<app-sub-navbar></app-sub-navbar>
<!-- content -->

<section class="pad-bottom container-fluid">
  <div class="row">
    <div class="col-lg-9 justify-content-center" #contentColumn>
      <div class="view">
        <!-- detail preview -->
        <!-- <div class="d-flex justify-content-center py-2">
          <div class="position-relative lg-image-wrapper"  
          [class.loading]="!illusImageLoaded"
          [style.aspect-ratio]="illusAspectRatio">
            
            <div class="lg-skeleton" *ngIf="!illusImageLoaded"></div>

            <img
              [src]="illusData?.previewUrl || illusData?.jpeg || illusData?.png"
              class="img-fluid img-radius lg-image"
              alt="{{ illusData?.title }}"
              (load)="onIllusImageLoad($event)"
            />
            <div
              class="position-absolute"
              style="top: 10px; left: 10px"
              *ngIf="illusData.isPremium && illusImageLoaded"
            >
              <span class="badge rounded cursor text-bg-dark">Pro</span>
            </div>
          </div>
        </div> -->


        <div class="image-shell mb-3" [class.loaded]="illusImageLoaded">
          <img [src]="getSEOImage(illusData?.previewUrl || illusData?.jpeg || illusData?.png)" [attr.width]="illusWidth" [attr.height]="illusHeight"
            class="lg-image img-radius img-fluid"  alt="{{ illusData?.title }}" (load)="onIllusImageLoad($event)" />

          <div class="lg-skeleton" *ngIf="!illusImageLoaded"></div>

          <span class="badge pro rounded cursor text-bg-dark" *ngIf="illusData?.isPremium && illusImageLoaded">
            Pro
          </span>
        </div>

        <div class="justify-content-start py-2">
          <!-- title of Illustrations -->
          <h1 class="fs-4 hide-lg text-dark">{{ illusData?.title }}</h1>
        </div>

        <!-- Mobile view Download option -->

        <div class="show-mob-view">
          <div class="mt-2 gap-2 d-grid justify-content-sm-start d-sm-flex">
            <!-- <button
              type="button"
              class="w-100 btn fw-semi btn-outline-black rounded-3"
              data-bs-toggle="modal"
              data-bs-target="#downloadedModal"
              (click)="
                setUrl(illusData?.jpeg || illusData?.png, illusData?.svg, 'svg')
              "
              *ngIf="user?.isSubscribed"
            >
              SVG
            </button> -->

            <button
              type="button"
              data-bs-dismiss="modal"
              data-bs-toggle="modal"
              data-bs-target="#downloadedModal"
              class="w-100 me-2 fs-6 fw-semi btn btn-outline-black rounded-3"
              [disabled]="isFetchingLimit || limitExceeds"
              (click)="setUrl(illusData)"
              *ngIf="
                user &&
                !user?.isSubscribed &&
                !illusData?.isPremium &&
                !limitExceeds
              "
            >
              <ng-container *ngIf="isFetchingLimit">
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                Loading...
              </ng-container>

              <ng-container *ngIf="!isFetchingLimit">
                {{ illusData?.jpeg ? "JPG" : "PNG" }}
              </ng-container>
            </button>

            <button
              *ngIf="
                user &&
                !user?.isSubscribed &&
                !illusData?.isPremium &&
                !isFetchingLimit &&
                limitExceeds
              "
              (click)="navigateToSubscribe()"
              class="w-100 fw-semi btn btn-ib-primary rounded-3"
            >
              Out of Downloads? Upgrade Pro
            </button>

            <!-- <button
              type="button"
              class="w-100 btn fw-semi btn-outline-black rounded-3"
              data-bs-dismiss="modal"
              data-bs-toggle="modal"
              data-bs-target="#downloadedModal"
              (click)="
                setUrl(illusData?.jpeg || illusData?.png, illusData?.png, 'png')
              "
              *ngIf="user?.isSubscribed"
            >
              JPG
            </button> -->
          </div>

          <div class="download py-1" *ngIf="user?.isSubscribed">
            <button
              type="button"
              class="w-100 btn fw-semi btn-ib-primary rounded-3"
              data-bs-toggle="modal"
              data-bs-target="#downloadedModal"
              (click)="setUrl(illusData)"
            >
              Download {{ illusData?.jpeg ? "JPG" : "PNG" }}
            </button>
          </div>

          <div
            class="download py-1"
            *ngIf="user && !user?.isSubscribed && illusData?.isPremium"
          >
            <button
              type="button"
              class="w-100 fw-semi btn btn-ib-primary rounded-3"
              (click)="navigateToSubscribe()"
            >
              Upgrade for Pro Files
            </button>
          </div>

          <div class="download py-1" *ngIf="!user">
            <button
              type="button"
              class="w-100 fw-semi btn btn-ib-black rounded-3"
              (click)="navigateToLogin()"
            >
              Login to Download
            </button>
          </div>

          <div class="justify-content-between mb-2 d-flex flex-wrap">
            <!-- before like showing this button -->

            <button
              type="button"
              class="w-100 fs-6 btn btn-ib-light my-2"
              (click)="addToFavorite(illusData)"
            >
              <i
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Like"
                [class]="wishListAdded ? 'fas fa-heart red' : 'fas fa-heart'"
              ></i
              ><span> {{ wishListAdded ? "Liked" : "Like" }}</span>
            </button>

            <!-- liked after showing this button -->

            <!-- <button type="button" class="w-50 me-2 fs-6 btn btn-ib-light-red my-2">
            <i data-bs-toggle="tooltip" data-bs-placement="top"
            title="Like" class="fas fa-heart"></i>
          </button> -->

            <!-- <button class="w-10 fs-6 btn btn-lg btn-ib-light me-2 my-2">
              <i
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="facebook"
                class="fa-brands fa-facebook"
                (click)="socialShare('fb')"
              ></i>
            </button>
            <button class="w-10 fs-6 btn btn-lg btn-ib-light me-2 my-2">
              <i
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="whatsapp"
                class="fa-brands fa-whatsapp"
                (click)="socialShare('wa')"
              ></i>
            </button> -->

            <div class="social-buttons">
              <a
                class="btn btn-ib-light my-2"
                [href]="encodedWhatsAppUrl"
                target="_blank"
                rel="noopener"
              >
                <img
                  src="assets/img/whatsapp.png"
                  style="width: 1rem; height: 1rem"
                  alt="WhatsApp"
                />
              </a>

              <a
                class="btn btn-ib-light my-2"
                [href]="encodedFacebookUrl"
                target="_blank"
                rel="noopener"
              >
                <img
                  src="assets/img/facebook.png"
                  style="width: 1rem; height: 1rem"
                  alt="Facebook"
                />
              </a>
            </div>
          </div>

          <div class="license mb-2">
            <h4 class="fs-6 text-dark fw-bold">Illusbook License</h4>
            <p class="text-dark">
              Free for personal and commercial purpose with attribution.
              <a
                href="#"
                data-bs-toggle="modal"
                data-bs-target="#licenseModal"
                class="text-red fw-bold"
                >More info</a
              >
            </p>
          </div>
        </div>
      </div>

      <div class="py-4 related " *ngIf="visibleRelatedData.length > 0">
        <h5 class="fw-bold py-2">Related AI Images</h5>

        <div class="masonry-container" #masonryContainer>
          <div class="masonry-item" *ngFor="let data of visibleRelatedData; let i = index">
            <figure class="showcase">
              <div class="badge-wrap" *ngIf="data.isPremium && data.imageLoad">
                <span class="badge rounded cursor text-bg-dark">Pro</span>
              </div>

              <!-- Skeleton (auto visible before image load) -->
              <div class="skeleton" *ngIf="!data.imageLoad"></div>

              <a routerLink="/ai-image/{{ data.slug }}">
                <img
                  [src]="getSEOImage(data?.previewUrl || data.jpeg || data.png)"
                  [alt]="data.title"
                  class="radius-md img-fluid"
                  (load)="onImageLoad(i, $event)"
                  loading="lazy"
                />

                <figcaption class="hide-caption figure-caption">
                  <p>{{ data.title }}</p>
                </figcaption>
              </a>
            </figure>
          </div>
        </div>

         <!-- 🔹 Load More Row (SEPARATE ROW) -->
          <div class="row my-4" *ngIf="!loader && hasMoreIllus">
            <div class="col-12 d-flex justify-content-center">

              <button class="btn fw-semi btn-outline-black rounded-3 px-4 py-2
                      d-flex align-items-center gap-2" (click)="loadMoreIllus()" [disabled]="isLoadingMore">

                <span *ngIf="isLoadingMore" class="spinner-border spinner-border-sm"></span>

                <span>{{ isLoadingMore ? 'Loading...' : 'Load more' }}</span>

              </button>

            </div>
          </div>
      </div>
    </div>

    <div class="col-lg-3 justify-content-center">
      <aside
        class="d-none d-lg-block side bd-toc mt-4 mb-5 my-md-0 ps-xl-3 mb-lg-5 text-muted"
      >
        <div class="download-section">
          <!-- Illusbook promotion -->
          <!-- <div class="ads-2">
            <img class="img-fluid" src="../../../../assets/img/placeholder-2.png" alt="">
        </div> -->

          <h4 class="fw-semi text-dark py-3 mt-4">{{ illusData?.title }}</h4>

          <!-- Desktop view download option -->

          <div class="justify-content-sm-between d-sm-flex">
            <!-- <button
              type="button"
              data-bs-dismiss="modal"
              data-bs-toggle="modal"
              data-bs-target="#downloadedModal"
              class="w-100 me-2 fs-6 fw-semi btn btn-outline-black rounded-3"
              (click)="
                setUrl(illusData?.jpeg || illusData?.png, illusData?.svg, 'svg')
              "
              *ngIf="user?.isSubscribed"
            >
              SVG
            </button> -->

            <button
              type="button"
              data-bs-dismiss="modal"
              data-bs-toggle="modal"
              data-bs-target="#downloadedModal"
              class="w-100 me-2 fs-6 fw-semi btn btn-outline-black rounded-3"
              [disabled]="isFetchingLimit || limitExceeds"
              (click)="setUrl(illusData)"
              *ngIf="
                user &&
                !user?.isSubscribed &&
                !illusData?.isPremium &&
                !limitExceeds
              "
            >
              <ng-container *ngIf="isFetchingLimit">
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                Loading...
              </ng-container>

              <ng-container *ngIf="!isFetchingLimit">
                {{ illusData?.jpeg ? "JPG" : "PNG" }}
              </ng-container>
            </button>

            <button
              *ngIf="
                user &&
                !user?.isSubscribed &&
                !illusData?.isPremium &&
                !isFetchingLimit &&
                limitExceeds
              "
              (click)="navigateToSubscribe()"
              class="w-100 fw-semi btn btn-ib-primary rounded-3"
            >
              Out of Downloads? Upgrade Pro
            </button>

            <!-- <button
              type="button"
              data-bs-dismiss="modal"
              data-bs-toggle="modal"
              data-bs-target="#downloadedModal"
              class="w-100 me-2 fs-6 fw-semi btn btn-outline-black rounded-3"
              (click)="
                setUrl(illusData?.jpeg || illusData?.png, illusData?.jpeg, 'jpeg')
              "
              *ngIf="user?.isSubscribed"
            >
              Download JPG
            </button> -->
          </div>

          <div class="download py-1" *ngIf="user?.isSubscribed">
            <button
              type="button"
              class="w-100 btn fw-semi btn-ib-primary rounded-3"
              data-bs-toggle="modal"
              data-bs-target="#downloadedModal"
              (click)="setUrl(illusData)"
            >
              Download {{ illusData?.jpeg ? "JPG" : "PNG" }}
            </button>
          </div>

          <div
            class="download py-1"
            *ngIf="user && !user?.isSubscribed && illusData?.isPremium"
          >
            <button
              type="button"
              class="w-100 fw-semi btn btn-ib-primary rounded-3"
              (click)="navigateToSubscribe()"
            >
              Upgrade for Pro Files
            </button>
          </div>

          <div class="download py-1" *ngIf="!user">
            <button
              type="button"
              class="w-100 fw-semi btn btn-ib-black rounded-3"
              (click)="navigateToLogin()"
            >
              Login to Download
            </button>
          </div>

          <div class="justify-content-between d-flex flex-wrap">
            <!-- before like showing this button -->

            <button
              type="button"
              class="w-100 fs-6 btn btn-ib-light my-2"
              (click)="addToFavorite(illusData)"
            >
              <i
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Like"
                [class]="wishListAdded ? 'fas fa-heart red' : 'fas fa-heart'"
              ></i
              ><span> {{ wishListAdded ? "Liked" : "Like" }}</span>
            </button>

            <div class="social-buttons mb-3">
              <a
                class="btn btn-ib-light my-2"
                [href]="encodedWhatsAppUrl"
                target="_blank"
                rel="noopener"
              >
                <img
                  src="assets/img/whatsapp.png"
                  alt="WhatsApp"
                  style="width: 1rem; height: 1rem"
                />
              </a>

              <a
                class="btn btn-ib-light my-2"
                [href]="encodedFacebookUrl"
                target="_blank"
                rel="noopener"
              >
                <img
                  src="assets/img/facebook.png"
                  alt="Facebook"
                  style="width: 1rem; height: 1rem"
                />
              </a>
            </div>
          </div>
          <div class="license">
            <h4 class="fs-6 text-dark fw-bold">Illusbook License</h4>
            <p class="text-dark">
              <span *ngIf="!illusData.isPremium"
                >Free for personal and commercial use with attribution.</span
              >
              <span *ngIf="illusData.isPremium"
                >Use for personal and commercial use without attribution.</span
              >&nbsp;
              <a
                href="#"
                data-bs-toggle="modal"
                data-bs-target="#licenseModal"
                class="text-black fw-bold"
                >More info</a
              >
            </p>
          </div>
        </div>
      </aside>
    </div>
  </div>
</section>

<div class="modals" *ngIf="user">
  <!-- Click svg, png, download all btn show this modal -->

  <div
    class="modal fade"
    id="downloadedModal"
    tabindex="-1"
    aria-labelledby="downloadedModalLabel"
    aria-hidden="true"
    *ngIf="!limitExceeds"
  >
    <div
      class="modal-dialog modal-dialog-scrollable modal-xl modal-dialog-centered"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="downloadedModalLabel">Thank You!</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="row">
              <div class="text-center py-1 col-md-5">
                <img
                  style="height: 256px !important"
                  [src]="imgUrl"
                  class="skeleton-3 img-fluid"
                />
              </div>

              <div class="py-2 col-md-7 my-auto">
                <h4 class="mb-3">Thank you for download this illustration!</h4>
                <a href="/" class="btn btn-lg btn-ib-black"> Explore </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- License, show this modal -->

<div
  #licenseModal
  class="modal fade"
  id="licenseModal"
  tabindex="-1"
  aria-labelledby="licenseModalLabel"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-scrollable modal-lg modal-dialog-centered"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="downloadedModalLabel">License summary</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="container">
          <div class="row">
            <div class="py-2 col-md-12 mx-auto">
              <div class="license-features">
                <div *ngIf="illusData.isPremium">
                  <h2 class="fs-4 fw-bold mb-3">
                    Pro License: All Free Benefits and Plus Extra Rights
                  </h2>

                  <p class="mb-2">
                    <i class="fa-solid fa-check"></i> &nbsp; High-resolution
                    exclusive assets
                  </p>

                  <p class="mb-2">
                    <i class="fa-solid fa-check"></i> &nbsp; Use in paid ads,
                    packaging, and products for sale
                  </p>

                  <p class="mb-2">
                    <i class="fa-solid fa-check"></i> &nbsp; Extended commercial
                    rights
                  </p>

                  <p class="mb-2">
                    <i class="fa-solid fa-check"></i> &nbsp; No attribution
                    required
                  </p>

                  <p class="mb-2">
                    <i class="fa-solid fa-check"></i> &nbsp; Priority for
                    professional use cases
                  </p>
                </div>

                <div *ngIf="!illusData.isPremium">
                  <h2 class="fs-4 fw-bold mb-2">Free License Usage Rights</h2>

                  <p class="attribution text-secondary mb-4">
                    You may use our illustrations for free in both personal and
                    commercial projects, as long as proper attribution is
                    provided. You can include an attribution line such as:
                    <a href="#" (click)="copyAttribution($event)"
                      >Designed by Illusbook</a
                    >
                    on your final product or design, whether digital or
                    physical.
                  </p>

                  <h3 class="fs-5 fw-bold mb-3">This license allows you to:</h3>

                  <p class="mb-2">
                    <i class="fa-solid fa-check"></i> &nbsp; For commercial and
                    personal projects
                  </p>
                  <p class="mb-2">
                    <i class="fa-solid fa-check"></i> &nbsp; On digital or
                    printed media
                  </p>
                  <p class="mb-2">
                    <i class="fa-solid fa-check"></i> &nbsp; For an unlimited
                    number of times, continuously
                  </p>
                  <p class="mb-2">
                    <i class="fa-solid fa-check"></i> &nbsp; From anywhere in
                    the world
                  </p>
                  <p class="mb-2">
                    <i class="fa-solid fa-check"></i> &nbsp; With modifications
                    or to create derivative works
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
